import * as React from 'react'

import { MultiSelect } from '@workwave-tidal/core/components'
import { SalesTeamOption } from '@user/components/Dashboard/widgets/hooks'
import MenuItem from '@mui/material/MenuItem'
import { SalesTeamMenuItemLabel } from '@user/components/Settings/SalesTeams/utils'
import { useData, useHandlers } from './hooks'
import ListItemIcon from '@mui/material/ListItemIcon'
import Checkbox from '@mui/material/Checkbox'

type Props = {
  leaveOwners?: boolean
  testIdPrefix?: string
}

export function SalesTeamMultiselect(props: Props) {
  const { leaveOwners, testIdPrefix = 'sales-team-multiselect' } = props
  const { value, options } = useData()
  const { renderSummary, handleSelectSalesTeam, matchFilter, isOptionEqual } =
    useHandlers({ leaveOwners })

  return (
    <MultiSelect<SalesTeamOption>
      items={options}
      label="Sales Teams"
      optionMode="custom"
      inputMode="summary"
      density="normal"
      value={value}
      onChange={handleSelectSalesTeam}
      matchFilter={matchFilter}
      textFieldProps={{
        //@ts-expect-error pendo requires data-test-id to be on the root element of the component
        ['data-test-id']: `${testIdPrefix}`,
      }}
      autocompleteProps={{
        isOptionEqualToValue: isOptionEqual,
        size: 'small',
      }}
      renderOption={(props, team: SalesTeamOption) => (
        <MenuItem {...props} key={team.id} value={team.id}>
          <ListItemIcon>
            <Checkbox checked={value.includes(team)} size="small" />
          </ListItemIcon>
          <SalesTeamMenuItemLabel salesTeam={team} />
        </MenuItem>
      )}
      renderSummary={(options) => renderSummary(options, 'Sales Teams')}
      placeholder="Search more Sales Teams"
      getLabel={(team) => team.name}
    />
  )
}
